import UserApi from './rest/UserApi';

export default new UserApi();
